import { ShopOutDTO } from "./shop.out.dto";
import { Type } from "class-transformer";

export class ShopPaginatedOutDTO {
  @Type(() => ShopOutDTO)
  shops!: ShopOutDTO[];

  total!: number;
}
